import { useDispatch, useSelector } from 'react-redux';
import useImpression from '../../useImpression';
import { IRootState } from '../../../store';
import getFlagValue, { FLAG_ENUM } from '../../../helpers/utils/getFlagValue';
import { addQueueProductKnowledgeCount } from '../../../store/emarsys/action';

const useImpressionProductKnowledgeList = (
  firstRef: React.RefObject<HTMLElement>,
  title: string,
  category: string,
  pageNumber: number,
  sectionName: string = ''
) => {
  const dispatch = useDispatch();
  const { isLargeScreen } = useSelector((state: IRootState) => state.page) || {
    isLargeScreen: false,
  };
  const { isAuth, userData } = useSelector((state: IRootState) => state.auth) || {
    isAuth: false,
    userData: null,
  };

  useImpression(
    firstRef,
    1,
    () => {
      const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
      const isFlagProductKnowledgeActive = getFlagValue(FLAG_ENUM.EMARSYS_PRODUCT_KNOWLEDGE_LIST);
      if (isAuth && isFlagActive && isFlagProductKnowledgeActive) {
        const valuePageView: Record<string, string | number | boolean> = {
          page_name: 'review produk listing page',
          page_url: window.location.href,
          page_title: title,
          page_category: category?.toLowerCase(),
          section_name: sectionName,
          page_number: pageNumber,
        };

        for (const key in valuePageView) {
          if (typeof valuePageView[key] !== 'boolean' && !valuePageView[key]) {
            delete valuePageView[key];
          }
        }

        if (userData?.customerNo) {
          ScarabQueue.push(['setCustomerId', userData?.customerNo]);
        }
        ScarabQueue.push(['tag', 'impressions', valuePageView]);

        dispatch(addQueueProductKnowledgeCount());
      }
    },
    {
      rootMargin: isLargeScreen ? '-161px 0px 0px 0px' : '-106px 0px 0px 0px',
    },
    [isAuth, category],
    isLargeScreen ? 161 : 106,
    isLargeScreen ? 0 : 0
  );

  return null;
};

export default useImpressionProductKnowledgeList;
